'use client';

import React from 'react';
import { IconPetsAllowed } from '@repo/svgs';

export function PetPolicyModal() {
  return (
    <div className="flex flex-col gap-4 px-2">
      <IconPetsAllowed className="w-8 h-8 text-success" />
      <p className="text-body-2 text-primary">This building is pet friendly.</p>
      <div className="bg-secondary rounded-2xl p-4">
        <p className="text-body-2 text-secondary">
          At Openigloo, we crowdsource tenant reviews to determine if a building is pet-friendly. We
          update this status when at least one tenant reports that the building is pet-friendly.
        </p>
      </div>
    </div>
  );
}
